module.exports = __webpack_public_path__ + "static/media/ca.7761e487.svg";